// konstanty pro firemni hodnoceni
export const MAX_LEN = 2500;
export const CLAMP_LEN_CHARS = 500;
export const CLAMP_LEN_LINES = 10;
// odkazy pro vlastni recenze
export const RULES_LINKS = {
	cs: "https://napoveda.firmy.cz/obecna-pravidla-pro-profily/pravidla-pro-recenze/",
	sk: "https://napoveda.firmy.cz/obecna-pravidla-pro-profily/pravidla-pro-recenze/",
	en: "https://napoveda.firmy.cz/evaluation-of-firms/",
};
export const RULES_LINKS_NOFIRM = {
	cz: "https://help.mapy.com/cs/hodnoceni/pravidla/",
	sk: "https://help.mapy.com/sk/hodnotenie/pravidla/",
	en: "https://help.mapy.com/en/ratings/rules/",
	de: "https://help.mapy.com/de/bewertung/richtlinien/",
	pl: "https://help.mapy.com/pl/oceny/zasady-dodawania-ocen/",
	it: "https://help.mapy.com/it/valutazione/linee-guida/",
};
// odkazy pro reakce na recenze
export const RESPOND_LINKS = {
	cs: "https://napoveda.firmy.cz/obecna-pravidla-pro-profily/smluvni-podminky/",
	en: "https://napoveda.seznam.cz/en/conditions/",
};
export const HIDE_CLASS = "hide";
export const LOADING_CLASS = "loading";
// parsovani casu pro mac
export const REPLACE_T_FORMAT = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/u;
// timeout pro zobrazeni srdicka po editaci
export const THANK_YOU_TO = 10000; // 10s
// zobrazeni dekovneho obrazku po hodnoceni
export const REVIEW_THANK_YOU_TO = 3000; // 3s

// smazani - duvody
interface IReasonItem {
	id: number;
	transText: string;
	fillText?: boolean;
}

export const REMOVE_REASONS_LIST: Array<IReasonItem> = [{
	id: 1,
	transText: "detail.content.review2.remove.reason1",
}, {
	id: 2,
	transText: "detail.content.review2.remove.reason2",
}, {
	id: 3,
	transText: "detail.content.review2.remove.reason3",
}, {
	id: 4,
	fillText: true,
	transText: "detail.content.review2.report.reason4",
}];
export const REMOVE_REASONS_LIST_NOFIRM: Array<IReasonItem> = [];
export const REMOVE_REFUSE_REASON_ID = 5;
export const REMOVE_MIN_COUNT = 5;

export const REVIEWS_LIST_SORT_OPTIONS = [{
	title: "mymap.reviews.sortDefaultAsc",
	value: "",
}, {
	title: "mymap.reviews.sortDateDesc",
	value: "latest",
}, {
	title: "mymap.reviews.sortDateAsc",
	value: "oldest",
}, {
	title: "mymap.reviews.sortRatingDesc",
	value: "best",
}, {
	title: "mymap.reviews.sortRatingAsc",
	value: "worst",
}];

export const POS_SMILEY_VAL = 100;
export const NEG_SMILEY_VAL = 0;
export const UNSET_SMILEY_VAL = null;

export const FULLTEXT_REVIEW = "fulltext";
export const FULLTEXT_REVIEW_SOURCE = "vyhledavani";

// hodnoceni BE, fotky, strukturovane hodnoceni
// eslint-disable-next-line no-constant-binary-expression
export const REVIEW_DEBUG = 0 && location.href.indexOf("mapy.c") === -1;
